/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import Card from "src/components/cards/Card.react";

import InsulationResistance from "src/views/report/custom/InsulationResistance.react";
import TransformerOilLeak from "src/views/report/custom/TransformerOilLeak.react";

/**
 * The Ground component
 *
 * @author Thais Watanabe
 */
const Ground = (props) => {
  const {
    turbineInspection,
    inspectionModelItems,
    results,
    lastResults,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
  } = props;

  const lastOneYear = lastTurbineInspections.find((obj) =>
    obj.inspection.type.startsWith("1年")
  );

  const lastHalfYear = lastTurbineInspections.find((obj) =>
    obj.inspection.type.startsWith("半年")
  );

  // 13-2
  const i13_2 = inspectionModelItems.filter((obj) => obj.name === "13-2")?.[0];
  const r13_2 = results.filter((obj) => obj.itemId === "13-2")?.[0];
  const last_r13_2 = lastResults?.filter(
    (obj) => obj.itemId === "13-2" && obj.turbineInspectionID === lastOneYear
  )?.[0];

  // 13-3
  const i13_3 = inspectionModelItems.filter((obj) => obj.name === "13-3")?.[0];
  const r13_3 = results.filter((obj) => obj.itemId === "13-3")?.[0];
  const last_r13_3 = lastResults?.filter(
    (obj) => obj.itemId === "13-3" && obj.turbineInspectionID === lastOneYear
  )?.[0];

  return (
    <>
      <Card title="エアギャップ測定結果表" className="print:mt-2">
        <div className="grid gap-x-4 grid-cols-2 print:gap-x-2">
          <InsulationResistance
            inspection={inspection}
            title={"今回"}
            inspectionModel={i13_2}
            result={r13_2}
            lastTurbineInspections={lastTurbineInspections}
            openEdit={openEdit}
            openObs={openObs}
            turbineInspection={turbineInspection}
            isPastInspection={false}
          />
          <InsulationResistance
            inspection={inspection}
            title={lastOneYear?.inspection?.name}
            inspectionModel={i13_2}
            result={last_r13_2}
            lastTurbineInspections={lastTurbineInspections}
            openEdit={openEdit}
            openObs={openObs}
            turbineInspection={turbineInspection}
            isPastInspection={true}
          />
        </div>
      </Card>

      <Card title="トランス油漏れ箇所点検表" className="print:mt-2">
        <div className="grid gap-x-4 grid-cols-2 print:gap-x-2">
          <TransformerOilLeak
            inspection={inspection}
            title={"今回"}
            inspectionModel={i13_3}
            result={r13_3}
            lastTurbineInspections={lastTurbineInspections}
            openEdit={openEdit}
            openObs={openObs}
            turbineInspection={turbineInspection}
            isPastInspection={false}
          />
          <TransformerOilLeak
            inspection={inspection}
            title={lastHalfYear?.inspection?.name ?? "点検なし"}
            inspectionModel={i13_3}
            result={last_r13_3}
            lastTurbineInspections={lastTurbineInspections}
            openEdit={openEdit}
            openObs={openObs}
            turbineInspection={turbineInspection}
            isPastInspection={true}
          />
        </div>
      </Card>
    </>
  );
};

export default Ground;
